// 文件路径: src/store/index.js
import { createStore } from 'vuex';
import { pixelAddToCart } from '@/plugins/metaPixel';

const store = createStore({
  state: {
    redirectPath: parseRedirectPath(localStorage.getItem('redirectPath')) || null,
    isLoggedIn: localStorage.getItem('isLoggedIn') === 'true', // 初始值从 localStorage 获取
    userProfile: getLocalStorageObject('userProfile', {}),  // 使用新函数来安全地获取 userProfile用立即执行函数来处理 userProfile 的初始化
    cartItems: getLocalStorageArray('cartItems', []),  // 新增購物車 - 從 localStorage 讀取或預設為空陣列
  },
  mutations: {
    setRedirectPath(state, path) {
      state.redirectPath = path
      // 存成 JSON:  { "path": "/checkout" }
      localStorage.setItem('redirectPath', JSON.stringify({ path: path }))
    },
    setLoggedIn(state, status) {
      state.isLoggedIn = status;
      localStorage.setItem('isLoggedIn', status.toString()); // 确保存储的是字符串
      //localStorage.setItem('cartItems', []);
    },
    setUserProfile(state, profile) {
      if (profile.addresses && Array.isArray(profile.addresses)) {
        profile.addresses.sort((a, b) => b.is_default - a.is_default);
      }
      state.userProfile = profile;
      localStorage.setItem('userProfile', JSON.stringify(profile)); // 更新 localStorage
    },
    // 關於購物車的 mutations
    setCartItems(state, items) {
      console.log(items);
      state.cartItems = items;
      localStorage.setItem('cartItems', JSON.stringify(items));
    },
    addToCart(state, { product, quantity }) {
      {{product}}
      // 檢查是否已有相同商品 (可以依你後端的 product_id 或其他唯一值)
      const existingItem = state.cartItems.find(item => 
        item.product_id === product.product_id &&
        item.variant_id === product.variant_id
      );
      if (existingItem) {
        // 若已有相同 (product_id, variant_id)，就累加數量
        existingItem.quantity += quantity;
      } else {
        // 若沒有，則在 cartItems 裡新增加一筆
        state.cartItems.push({
          ...product,   // 例如 { product_id, variant_id, variant_name, discount_price, image_url ...}
          quantity
        });
      }
      // 同步更新 localStorage
      localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
      // Meta Pixel：加入購物車事件（所有加購路徑都會經過這裡）
      pixelAddToCart({
        id: product.product_id,
        name: product.title || product.variant_name,
        variant: product.variant_name,
        price: product.discount_price,
        quantity
      });
    },
    removeFromCart(state, { productId, variantId }) {
      console.log('removeFromCart:', productId, variantId);
      state.cartItems = state.cartItems.filter(item =>
        !(item.product_id === productId && item.variant_id === variantId)
      );
      localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
    },
    
    
    clearCart(state) {
      state.cartItems = [];
      localStorage.removeItem('cartItems');
    },
  },
  actions: {
    login({ commit }, profile) {
      commit('setLoggedIn', true);
      commit('setUserProfile', profile);
    },
    logout({ commit }) {
      commit('setLoggedIn', false);
      commit('setUserProfile', {});
      localStorage.removeItem('isLoggedIn'); // 清除 isLoggedIn 状态
      localStorage.removeItem('userProfile'); // 清除 userProfile 数据

      // commit('clearCart');
    },
    addProductToCart({ commit }, { product, quantity }) {
      // 也可在這裡做一些檢查或後端呼叫
      commit('addToCart', { product, quantity });
    },
    removeProductFromCart({ commit }, { productId, variantId }) {
      commit('removeFromCart', { productId, variantId });
    },    
    clearAllCart({ commit }) {
      commit('clearCart');
    },
  },
  getters: {
    imagePath: () => (filename) => {
      return require(`@/assets/images/${filename}`);
    },
    cartCount: (state) => {
      // 計算商品總數量
      return state.cartItems.reduce((sum, item) => sum + item.quantity, 0);
    },
    cartTotal: (state) => {
      // 計算商品總金額(假設使用 discount_price 為單價)
      return state.cartItems.reduce((total, item) => {
        return total + (item.discount_price * item.quantity);
      }, 0);
    },

  },
});

// 幫忙 parse
function parseRedirectPath(item) {
  if (!item) return null
  try {
    const obj = JSON.parse(item)
    // obj 應該長這樣 { path: "/checkout" }
    return obj.path || null
  } catch (e) {
    console.error(e)
    return null
  }
}

function getLocalStorageObject(key, defaultObj = {}) {
  const item = localStorage.getItem(key);
  if (!item || item === 'null') return defaultObj;
  try {
    const parsed = JSON.parse(item);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed;
    }
    return defaultObj;
  } catch (e) {
    console.error(`Error parsing object from key: ${key}`, e);
    return defaultObj;
  }
}

function getLocalStorageArray(key, defaultArr = []) {
  const item = localStorage.getItem(key);
  if (!item || item === 'null') return defaultArr;
  try {
    const parsed = JSON.parse(item);
    if (Array.isArray(parsed)) {
      return parsed;
    }
    return defaultArr;
  } catch (e) {
    console.error(`Error parsing array from key: ${key}`, e);
    return defaultArr;
  }
}


export default store;
